import { useMatches } from 'react-router';
import { useMemo } from 'react';
import type { ArticleDetailsProps } from '@modules/article';
import type { TopBanner } from '@modules/page-builder/types';
import type { PageBuilderModuleType } from '@modules/page-builder/types';

const ARTICLE_ROUTE = `routes/_app.article.$article._index`;
const PREVIEW_ROUTE = `routes/_app.article.$article.template.$url`;

interface CombinedDataType {
    details: ArticleDetailsProps;
    banner: TopBanner;
    modules: PageBuilderModuleType[];
    templateBanner: TopBanner;
    templateModules: PageBuilderModuleType[];
    templateIntroText: string;
}

export const useArticlePreviewRouteData = () => {
    const matchingRoutes = useMatches();

    const combinedData = useMemo(() => {
        const filteredRoutes = matchingRoutes.filter((route) => {
            return [ARTICLE_ROUTE, PREVIEW_ROUTE].includes(route.id);
        });

        return filteredRoutes.reduce((result, item) => {
            Object.assign(result, item.data);
            return result;
        }, {} as CombinedDataType);
    }, [matchingRoutes]);

    const {
        // from article
        details,
        banner,
        modules,
        // from template
        templateBanner,
        templateModules,
        templateIntroText,
    } = combinedData;

    if (details && !details.introText) {
        details.introText = templateIntroText;
    }

    return {
        details,
        banner: templateBanner ?? banner,
        modules: templateModules ?? modules,
    };
};
